<template>
  <button class="btn-login" @click="openModal">ログイン・アカウント作成</button>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: false
    }
  },
  methods: {
    openModal: function() {
      if (this.callback) {
        this.callback();
      }
      // document.body.className = "overflow-hidden-nofixed";
      this.$root.$refs.loginModal.open(); 
    }
  }
};
</script>